// Libraries
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { GenericFormComponent } from './generic-form.component';

const COMPONENTS: any = [
  GenericFormComponent
];

/**
 * `FormErrorsModule` defines a module to manage frontend and backend errors.
 *
 * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
 * @export
 */
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ...COMPONENTS
  ],
  exports: [
    ...COMPONENTS
  ]
})
export class FormErrorsModule {}
